import Vue from 'vue'
import VueRouter from 'vue-router'



const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter);

import entrance from '../components/entrance.vue'
import entranceWap from '../components/entranceWap.vue'
import entrancePc from '../components/entrancePc.vue'

const routes = [
    {
        path:'/',
        redirect:'/entrance',
    },
    {
        path: '/entrance',
        name: 'entrance',
        component: entrance,
    },
    {
        path: '/report',
        name: 'report',
        component: ()=>import('../components/report.vue'),
    },
    {
        path: '/percentage',
        name: 'percentage',
        component: ()=>import('../views/report/percentage.vue'),
    },
    {
        path: '/waitingPage',
        name: 'waitingPage',
        component: ()=>import('../views/report/waitingPage.vue'),
    },
    {
        path: '/entranceWap',
        name: 'entranceWap',
        component: entranceWap,
    },

    {
        path: '/entrancePc',
        name: 'entrancePc',
        component: entrancePc,
    },
   
   
]

const router = new VueRouter({
    routes,
});

router.afterEach(route => {
    window.scrollTo(0, 0);
})


export default router